import { MenuItem } from "primereact/menuitem";
import { BreadCrumb } from "primereact/breadcrumb";

import { Category } from "../categories/Category";

interface RoutingRuleCategoriesBreadCrumbProps {
  categories: Category[];
}

const CustomMenuItem = (item: MenuItem) => {
  return (
    <div className="flex align-items-center gap-2">
      <span className={`pi ${item.icon}`}></span>
      {item.label}
    </div>
  );
};

export default function RoutingRuleCategoriesBreadCrumb({ categories }: RoutingRuleCategoriesBreadCrumbProps) {
  const items: MenuItem[] = categories.map((c) => ({ label: c.name, icon: c.icon, template: CustomMenuItem }));

  return (
    <BreadCrumb
      model={items}
      pt={{
        root: { className: "pointer-events-none border-none" },
        menu: {
          className: "flex-wrap gap-2",
        },
        separator: {
          className: "m-0",
        },
      }}
    ></BreadCrumb>
  );
}
